<div class="text-center bg-white py-5">
    <i class="fas text-primary fa-exclamation-triangle fa-10x mb-3"></i>
    <h1 class="mb-3 font-black">{{ errorCode }}</h1>
    <h4 class="mb-0 text-primary">{{ "SERVER_ERROR" | translate | titlecase }}</h4>
</div>